<template>
<v-card>
  <v-row>
    <v-col cols="2">
      <v-list-item @click="samplesReadyForRelease">
        <v-list-item-content class="text-center">
          <v-list-item-subtitle >Samples Ready for Release</v-list-item-subtitle>
          <v-list-item-title class="text-center">
            <v-progress-circular v-if="loadingReadyForRelease" indeterminate size="10"></v-progress-circular>
            <span v-else>{{readyForRelease}}</span>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col cols="2">
      <v-list-item>
        <v-list-item-content class="text-center">
          <v-list-item-subtitle >Samples Processing</v-list-item-subtitle>
          <v-list-item-title class="text-center">{{ samplesProcessing }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col cols="2">
      <v-list-item>
        <v-list-item-content class="text-center">
          <v-list-item-subtitle >Samples Failed Process</v-list-item-subtitle>
          <v-list-item-title class="text-center">{{ samplesFailed }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col cols="2">
      <WaitingToBeEmailedDialog>
        <template v-slot:activator="{on}">
          <v-list-item v-on="on">
            <v-list-item-content class="text-center">
              <v-list-item-subtitle >Samples Waiting to be emailed</v-list-item-subtitle>
              <v-list-item-title class="text-center">{{ samplesWaitingForEmailer }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </WaitingToBeEmailedDialog>

    </v-col>
    <v-col cols="2">
      <FailedToBeEmailedDialog>
        <template v-slot:activator="{on}">
          <v-list-item v-on="on">
            <v-list-item-content class="text-center">
              <v-list-item-subtitle>Emails failed to send</v-list-item-subtitle>
              <v-list-item-title>0</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </FailedToBeEmailedDialog>

    </v-col>
  </v-row>
</v-card>
</template>

<script>
import Recorded from "@/Lib/Recorded";
export default {
  name: "ReleaseStats",
  components: {
    WaitingToBeEmailedDialog: () => import('./WaitingToBeEmailedDialog'),
    FailedToBeEmailedDialog: () => import('./FailedToBeEmailedDialog'),
  },
  props: {},
  data: () => ({
    readyForRelease: null,
    loadingReadyForRelease: false,
  }),
  computed: {
    samplesProcessing(){
      return Object.keys(this.$store.state.ReleaseSampleStore.samplesProcessing).length;
    },
    samplesFailed(){
      return Object.keys(this.$store.state.ReleaseSampleStore.samplesFailed).length;
    },
    samplesWaitingForEmailer(){
      return Object.keys(this.$store.state.ReleaseSampleStore.samplesAwaitingEmail).length;
    }
  },
  watch: {
    samplesProcessing(v, old){
      if(old > 0 && v === 0){
        this.samplesReadyForRelease();
      }
    }
  },
  mounted() {
    this.samplesReadyForRelease();
  },
  methods: {
    async samplesReadyForRelease(){
      this.loadingReadyForRelease = true;
      let query = await Recorded.get('/query', {
        table: 'samples',
        select: ['*'],
        where: [
          {column: 'qa_approved', operator: 'IS TRUE'},
          {column: 'is_released', operator: 'IS FALSE'},
          {column: 'order_id', operator: 'IS NOT NULL'}
        ],
        aggregate:{
          function: 'count',
          column: '*'
        }
      })
      // console.log(query, 'samples ready for release');
      this.readyForRelease = query.data[0].count;
      this.loadingReadyForRelease = false;
      // this.uniqueCustomers();
    },
    async uniqueCustomers(){
      let query = await Recorded.get('/query', {
        table: 'samples',
        select: ['customer_id'],
        where: [
          {column: 'qa_approved', operator: 'IS TRUE'},
          {column: 'is_released', operator: 'IS FALSE'},
          {column: 'order_id', operator: 'IS NOT NULL'}
        ],
        group_by: ['customer_id'],
      });
      let customerQuery = await this.$store.$db().model('customers').api().fetch({
        with: 'primaryName',
        where_in: {
          key: 'id',
          values: query.data.map(c => c.customer_id)
        }
      }, "", null, false, false);
      console.log('CUSTOMER QUERIES', customerQuery.response.data);
    }
  },
}
</script>

<style scoped>

</style>
